import { IconProps } from '.';

function AccordionAlert({ color, className }: IconProps) {
  return (
    <svg
      width="16"
      height="17"
      fill={color}
      viewBox="0 0 16 17"
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path fillRule="evenodd"
        clipRule="evenodd"
        d="M3.0161 16.4307C0.776681 16.4307 -0.679457 14.0729 0.321889 12.0695L5.30694 2.0958C6.41723 -0.124397 9.58397 -0.124397 10.6943 2.09589L15.6793 12.0695C16.6805 14.0726 15.2238 16.4307 12.9851 16.4307H3.0161ZM6.20132 2.54327L1.21632 12.5169C0.547383 13.8552 1.52015 15.4303 3.0161 15.4303H12.9851C14.4804 15.4303 15.4537 13.8549 14.7849 12.5169L9.79994 2.54337C9.05823 1.06023 6.94297 1.06023 6.20132 2.54327ZM8.5005 10.9509V5.91008C8.5005 5.63383 8.27664 5.40989 8.0005 5.40989C7.72436 5.40989 7.5005 5.63383 7.5005 5.91008V10.9509C7.5005 11.2271 7.72436 11.4511 8.0005 11.4511C8.27664 11.4511 8.5005 11.2271 8.5005 10.9509ZM8.0005 13.6599C7.6555 13.6599 7.3755 13.3798 7.3755 13.0346C7.3755 12.6895 7.6555 12.4094 8.0005 12.4094C8.3455 12.4094 8.6255 12.6895 8.6255 13.0346C8.6255 13.3798 8.3455 13.6599 8.0005 13.6599Z"
        fill={color} />
    </svg>
  );
}

export default AccordionAlert;
